'use client';

import { FireIcon } from '@repo/icons';
import { cn } from '@repo/utils/cn';
import { useTranslations } from 'next-intl';
import React, { useState } from 'react';
import { TAB_KEYS, getTabs, type tabKeyType } from '@/app/[locale]/(landing)/components/latest-activity/data';
import LatestActivityTable from '@/app/[locale]/(landing)/components/latest-activity/latest-activity-table';

const LatestActivity = () => {
  const t = useTranslations('landing.latest-activity');
  const [selectedTab, setSelectedTab] = useState<tabKeyType>(TAB_KEYS.CASINO_BETS);

  return (
    <section className="flex flex-col self-stretch">
      <div className="flex w-full flex-col items-start justify-between gap-2 px-0.5 sm:flex-row sm:items-center">
        <label className="vt-siderbar-item-primary-text flex items-center gap-x-1">
          <FireIcon
            className="size-5"
            fill="#EFEFEF"
          />
          <h2 className="font-black vt-font-highlight-font-family vt-text-size-medium vt-headings-text sm:vt-text-size-big">
            {t('title')}
          </h2>
        </label>
        <div className="my-1.5 flex justify-center gap-1 rounded-md p-1 vt-surface-lighter-bg sm:justify-end">
          {getTabs(t).map((tab) => (
            <button
              key={tab.key}
              className={cn(
                'flex items-center self-stretch rounded p-2',
                selectedTab === tab.key && '!bg-[var(--colors-accents-accent-2-600)] vt-headings-text'
              )}
              onClick={() => setSelectedTab(tab.key as tabKeyType)}
            >
              <span className="text-sm font-semibold vt-font-highlight-font-family">{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-6 self-stretch rounded-md border border-[var(--surface-lighter-bg)] p-2">
        <LatestActivityTable selectedTab={selectedTab} />
      </div>
    </section>
  );
};

export default LatestActivity;
